export const CURRENT_PAGE = 'CurrentPage';
export const USERSURVEY = 'USERSURVEY';
export const RESTORE_LIST = 'RESTORE_LIST';
export const STYLIST_SALONID = 'SalonId';
export const CUSTOMER = 'Customer';



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/localStorageKeys.js